import { useQuery } from '@tanstack/react-query';
import type { SiteContactPublic } from '../../shared/types/siteContact';
import { getApiUrl } from '../utils/apiClient';

async function fetchSiteContact(): Promise<SiteContactPublic> {
  const res = await fetch(getApiUrl('/config/site-contact'), { credentials: 'omit' });
  if (!res.ok) {
    throw new Error(`Site contact failed: ${res.status}`);
  }
  return res.json();
}

export function useSiteContact() {
  return useQuery({
    queryKey: ['site-contact'],
    queryFn: fetchSiteContact,
    staleTime: 120_000,
  });
}
